import React, { memo, useState, useEffect, useCallback } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Card, CardContent, Fab, LinearProgress } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { EUserOnboardingActionTypes } from 'models'
import _ from 'lodash'

import { UserOnboardingStateValue } from '../../reducer'
import styles from './styles'
import { combineStyles } from 'utils'
import generalStyles from 'styles/common'

const OnboardingProgressView: React.FunctionComponent<any> = ({
	basicInfoStep,
	detailsStep,
	experienceStep,
	userCvStep,
	handleSelectedStep,
	activeStep,
	userOnBoardDispatch,
	firstName,
	lastName,
	aboutMe,
}) => {
	const { t } = useTranslation()
	const combinedStyles: any = combineStyles(generalStyles, styles)
	const useStyles = makeStyles(combinedStyles)
	const classes = useStyles()
	const [steps, setSteps] = useState([
		{
			title: 'Basic Information',
			value: basicInfoStep,
			isActive: activeStep === 0,
		},
		{
			title: 'Details',
			value: detailsStep,
			isActive: activeStep === 1,
		},
		{
			title: 'Experience',
			value: experienceStep,
			isActive: activeStep === 2,
		},
		{
			title: 'CV',
			value: userCvStep,
			isActive: activeStep === 3,
		},
	])

	const handleGoToSelectedStep = useCallback(
		(nextStep: number) => {
			if (activeStep === nextStep) return
			switch (activeStep) {
				case 0:
					{
						const checkValidity: boolean =
							_.isEmpty(firstName) ||
							_.isEmpty(lastName) ||
							_.isEmpty(aboutMe)
						if (checkValidity) {
							userOnBoardDispatch({
								type: EUserOnboardingActionTypes.setError,
								errors: {
									firstName: _.isEmpty(firstName),
									lastName: _.isEmpty(lastName),
									aboutMe: _.isEmpty(aboutMe),
								},
							})
						} else handleSelectedStep(nextStep)
					}
					break
				case 1:
					{
						if (nextStep < activeStep) {
							handleSelectedStep(nextStep)
							return
						}
						const checkValidity: boolean = false
						if (checkValidity) {
						} else handleSelectedStep(nextStep)
					}
					break
				case 2:
					if (nextStep < activeStep) {
						handleSelectedStep(nextStep)
						return
					}
					handleSelectedStep(nextStep)

					break

				default:
					handleSelectedStep(nextStep)
					break
			}
		},
		[
			activeStep,
			handleSelectedStep,
			userOnBoardDispatch,
			firstName,
			lastName,
			aboutMe,
		],
	)

	useEffect(() => {
		setSteps([
			{
				title: 'Basic Information',
				value: basicInfoStep,
				isActive: activeStep === 0,
			},
			{
				title: 'Details',
				value: detailsStep,
				isActive: activeStep === 1,
			},
			{
				title: 'Experience',
				value: experienceStep,
				isActive: activeStep === 2,
			},
			{
				title: 'CV',
				value: userCvStep,
				isActive: activeStep === 3,
			},
		])
	}, [
		basicInfoStep,
		detailsStep,
		experienceStep,
		userCvStep,
		handleSelectedStep,
		activeStep,
	])

	let stepsChecked = 0
	let completed1 = 0

	steps.forEach(item => {
		if (item.value) stepsChecked++
	})
	completed1 = Math.ceil((stepsChecked / 4) * 100)
	return (
		<Card
			classes={{
				root: classNames(classes.cardRoot, classes.boxShadow),
			}}
		>
			<CardContent
				classes={{
					root: classes.cardContent,
				}}
			>
				<div className={classes.cardContentTitle}>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							flexFlow: 'row',
						}}
					>
						<span>{t('Welcome to CV30')}</span>
					</div>
					<div>{t('Set up your profile')}</div>
				</div>
				<div style={{ marginTop: '10px' }}>
					<LinearProgress
						variant="determinate"
						color="primary"
						value={completed1}
						classes={{
							barColorPrimary: classes.colorPrimary,
							root: classes.progressRoot,
							bar1Determinate: classes.bar1Determinate,
						}}
					/>
				</div>
				<div className={classes.progressSteps}>
					{steps?.map((item: any, index: any) => {
						let cursorStyle = { cursor: 'default' }
						return (
							<div
								key={`key-${index}`}
								className={classes.progressStepsItem}
								onClick={() => handleGoToSelectedStep(index)}
							>
								<Fab
									disabled={!item.value}
									className={classes.stepItem}
									classes={{
										disabled: classes.fabDisabled,
									}}
								>
									{item.value ? <CheckIcon /> : ''}
								</Fab>
								<span
									style={cursorStyle}
									className={
										item.value
											? classes.stepItemTitle
											: classes.stepTitleDisabled
									}
								>
									<span
										className={classNames({
											[classes.activeStep]: item.isActive,
										})}
									>
										{item.title}
									</span>
								</span>
							</div>
						)
					})}
				</div>
			</CardContent>
		</Card>
	)
}

const OnboardingProgress = memo((props: any) => (
	<UserOnboardingStateValue
		keys={[
			'id',
			'userOnBoardDispatch',
			'error',
			'firstName',
			'lastName',
			'aboutMe',
			'image',
		]}
	>
		<OnboardingProgressView {...props} />
	</UserOnboardingStateValue>
))

export default memo(OnboardingProgress)
